export default "__VITE_ASSET__CxwmsRHZ__"